var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInitZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#E9F7FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8581 11.0144L33.9249 16.2128C32.6413 17.2352 31.2392 19.1692 30.5007 20.5859L30.0023 21.5419L31.054 21.3048L32.4894 20.9812L35.3993 29.6923C34.0691 30.5521 33.4547 31.5795 32.898 32.5105C32.8482 32.5937 32.7989 32.6762 32.7496 32.7577C30.0697 31.7528 27.8235 31.2531 26.1718 31.5607C25.2818 31.7265 24.5437 32.1304 24.0215 32.8245C23.5747 33.4185 23.3149 34.1868 23.2177 35.1134C21.7276 35.2556 19.6071 35.3667 17.4771 35.0792C15.2244 34.7752 13.0338 34.0351 11.546 32.4897C12.4212 29.0994 12.9513 25.4591 12.2198 22.2935C11.4727 19.0604 9.41771 16.3641 5.23829 14.9391L4.67685 13.0292L11.7426 13.3335L12.3719 13.3606L12.2555 12.7416L11.5853 9.17784L12.4279 9.09459L13.1418 10.3814L13.3026 10.6712L13.6322 10.636C15.7694 10.4076 17.4025 9.62952 18.5161 8.49406C19.5308 7.45935 20.0879 6.15409 20.2151 4.77013C20.3848 4.73998 20.5939 4.70318 20.8077 4.66642C21.0592 4.62316 21.3153 4.58029 21.5211 4.54835C21.5852 4.53841 21.6434 4.52968 21.6945 4.5224C25.1733 7.78593 29.0561 10.4584 34.8581 11.0144Z",
    stroke: "#004D66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitZoom);
export default __webpack_public_path__ + "static/media/init-zoom.739a4326d171c9174004b05969e25072.svg";
export { ForwardRef as ReactComponent };